import { render, staticRenderFns } from "./addVersion.vue?vue&type=template&id=143263ce&scoped=true&"
import script from "./addVersion.vue?vue&type=script&lang=js&"
export * from "./addVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143263ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\drone_race_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('143263ce')) {
      api.createRecord('143263ce', component.options)
    } else {
      api.reload('143263ce', component.options)
    }
    module.hot.accept("./addVersion.vue?vue&type=template&id=143263ce&scoped=true&", function () {
      api.rerender('143263ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/divisionManage/versionManage/component/addVersion.vue"
export default component.exports